var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 40,
    viewBox: "0 0 164 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502",
    transform: "translate(-273 -1976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4241",
    "data-name": "Path 4241",
    d: "M20,0H144a20,20,0,0,1,0,40H20A20,20,0,0,1,20,0Z",
    transform: "translate(273 1976)",
    fill: "#d50304"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Add_To_Cart",
    "data-name": "Add To Cart",
    transform: "translate(328.5 2002)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Montserrat-Light, Montserrat",
    fontWeight: 300,
    letterSpacing: "0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add To Cart")), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286",
    "data-name": "Path 4286",
    d: "M5.2,9.456h8.574a.473.473,0,0,0,.455-.343l1.891-6.619a.473.473,0,0,0-.455-.6H4.109L3.771.37A.473.473,0,0,0,3.309,0H.473a.473.473,0,1,0,0,.946H2.93L4.637,8.627a1.418,1.418,0,0,0,.563,2.72h8.573a.473.473,0,1,0,0-.946H5.2a.473.473,0,0,1,0-.945Zm9.839-6.619L13.417,8.51H5.58L4.319,2.837Zm0,0",
    transform: "translate(301 1989.408)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.79d267bdcebe830e43d6abc1ce76f240.svg";
export { ForwardRef as ReactComponent };